import React from 'react';
import styled from 'styled-components/macro';
import Condition from './Condition';

const Button = styled.button`
  height: 1.7rem;
  width: 7rem;
  outline: none;
  border: none;
  background-color: transparent !important;
  max-width: 10rem;
  margin: 1rem 0;
  color: rgb(31, 93, 234) !important;
  border: 1px solid rgb(31, 93, 234);
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 10rem;
  overflow: scroll;
  padding: 0 1rem;
  padding-bottom: 3rem;
`;

interface Props {
  push: (newPropotion: any) => void;
  remove: (index: number) => void;
  values: [];
  questionsList: string[];
  fieldName: string;
  setFieldValue: (field: string, value: any) => void;
}

const Conditions = ({
  push,
  remove,
  values,
  questionsList,
  fieldName,
  setFieldValue,
}: Props) => {
  const questionOptions = questionsList.map((question: string) => ({
    name: question,
    value: question,
  }));

  const areConditions = values.length > 0;
  return (
    <Content>
      <Button
        onClick={() =>
          push({
            question: '',
            logic: areConditions ? '||' : null,
            logicOperator: '<',
            equals: '',
          })
        }
        type="button"
      >
        Add Condition
      </Button>

      {values.map(({ equals, logicOperator }, index: number) => {
        return (
          <Condition
            key={index}
            equals={equals}
            logicOperator={logicOperator}
            index={index}
            setFieldValue={setFieldValue}
            fieldName={fieldName}
            questionOptions={questionOptions}
            remove={remove}
          />
        );
      })}
    </Content>
  );
};

export default Conditions;
